import React from "react";

export const MANUAL_UPLOAD_LABELS = {
  SUBMITTING: "접수 중", CHECKING: "작업 확인 중", QUEUED: "업로드 대기 중", RUNNING: "업로드 진행 중",
  CHECK_REQUIRED: "상태 확인 필요", UNKNOWN: "접수 여부 확인 필요", NEEDS_REVIEW: "게시 여부 확인 필요",
  SUCCESS: "업로드 완료", FAILED: "업로드 실패", REJECTED: "요청 접수 안 됨",
};

export default function ManualUploadNotice({ upload }) {
  if (upload.phase === "IDLE") return null;
  const allowReview = () => {
    if (window.confirm("인스타 게시물과 컨시어지 히스토리를 직접 확인하셨습니까?\n기존 작업이 실제 게시됐거나 진행 중이면 새 요청은 중복 게시될 수 있습니다.\n확인 후 새 수동업로드 요청을 허용하시겠습니까?")) upload.releaseAfterReview();
  };
  return <section aria-label="수동업로드 작업 상태" className="mb-5 rounded border p-4 text-sm"
    style={{ background: "var(--cms-surface, #fff)", color: "var(--cms-text, #111827)", borderColor: "var(--cms-border, #d1d5db)" }}>
    <div role="status" aria-live="polite">
      <strong>{MANUAL_UPLOAD_LABELS[upload.phase] || "상태 확인 필요"}</strong>
      <p className="mt-2 whitespace-pre-wrap">{upload.message}</p>
      {upload.jobId && <p className="mt-1 break-all text-xs">작업 번호: {upload.jobId}</p>}
      {upload.phase === "CHECK_REQUIRED" && upload.status && <p className="mt-1 text-xs">마지막 확인 상태: {MANUAL_UPLOAD_LABELS[upload.status] || upload.status}</p>}
    </div>
    {upload.blocked && upload.phase !== "SUBMITTING" && <div className="mt-3 flex flex-wrap gap-2">
      <button type="button" className="rounded border px-3 py-2 disabled:opacity-50" onClick={upload.recheck} disabled={upload.checking}>
        {upload.checking ? "상태 조회 중..." : "상태 재조회"}
      </button>
      {upload.canRelease && <button type="button" className="rounded border px-3 py-2 disabled:opacity-50" onClick={allowReview} disabled={upload.checking}>게시 이력 확인 후 새 요청 허용</button>}
    </div>}
  </section>;
}
